/* global URL */
export default (
  defaultImage,
  property,
  maxWidth,
  maxHeight,
  perfectSquare
) => ({
  imageSrc: defaultImage,
  dropping: false,
  validType: true,
  dimensions: null,
  fileName: null,
  localError: null,
  previewImage(event) {
    const file = event.files[0];

    if (this.localError) this.localError = null;
    if (!file || !file.name || !file.type || !file.size) {
      this.discardImage(event);
      // Just show error in the UI and not as part of the form errors so users can still save the episode if they want to.
      this.localError =
        "Something went wrong uploading the image, please try again.";
      return;
    }

    const allowedTypes = ["image/png", "image/jpg", "image/jpeg"];

    if (this.fileName) {
      this.removeUploadedImage();
    }

    // Only preview image if type is valid
    if (!allowedTypes.includes(file.type)) {
      this.validType = false;
      this.imageSrc = null;
      this.dimensions = null;
      return;
    } else {
      this.validType = true;

      // Start upload through Livewire
      this.$wire.emit("uploadingImage", true);
      this.$wire.upload(
        property,
        file,
        (this.finishCallback = (uploadedFilename) => {
          this.fileName = uploadedFilename;
          this.$wire.emit("uploadingImage", false);
        }),
        (this.errorCallback = () => {
          this.$wire.emit("uploadingImage", false);
          this.discardImage();
          this.localError =
            "Something went wrong uploading the image, please check that you are using a supported file type and try again.";
        }),
        (this.progressCallback = () => {})
      );

      // Preview image in frontend
      this.imageSrc = URL.createObjectURL(file);
    }
  },
  validateImage(event) {
    const naturalWidth = event.target.naturalWidth;
    const naturalHeight = event.target.naturalHeight;

    const validAspectRatio = perfectSquare
      ? naturalWidth / naturalHeight === 1
      : true;

    // Checking valid values
    const validWidth = naturalWidth <= maxWidth;
    const validHeight = naturalHeight <= maxHeight;

    this.dimensions = {
      size: {
        valid: validWidth && validHeight,
        message: `Size found: ${naturalWidth} x ${naturalHeight}px.`,
      },
    };

    if (perfectSquare) {
      this.dimensions = {
        ...this.dimensions,
        ratio: {
          valid: validAspectRatio,
          message: validAspectRatio
            ? "Image is a square"
            : "Image should be a perfect square. It might be rejected by some directories.",
        },
      };
    }

    if (!validWidth && !validHeight) {
      this.$wire.call("addNewError", property);
    }
  },
  removeUploadedImage() {
    this.$wire.removeUpload(
      property,
      this.fileName,
      (this.finishCallback = () => {
        this.fileName = null;
      }),
      (this.errorCallback = () => {})
    );
  },
  discardImage() {
    // This only discards the currently uploaded image, it doesn't delete an image that's already attached to an episode
    if (this.$wire.get(property)) this.removeUploadedImage();

    defaultImage ? (this.imageSrc = defaultImage) : (this.imageSrc = null);
    this.dimensions = null;
    this.fileName = null;
    this.validType = true;

    this.$wire.call("resetErrorValidation", property);
  },
  trigger: {
    ["@remove-cover-image.window"]() {
      this.imageSrc = null;
    },
  },
});
